import React, { useEffect, useRef } from 'react';
import { IBoxConstraints, IPoint } from './interfaces';

interface IProps {
  boxConstraints: IBoxConstraints;
  scaleFactor: number;
  points: IPoint[];
  inverse?: boolean;
}

export function Ellipse(props: IProps) {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (!canvasRef.current) return;
    const canvas = canvasRef.current;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    if (props.points.length === 0) return;

    ctx.strokeStyle = props.inverse ? '#2196F3' : 'yellow';
    ctx.lineWidth = 3;
    ctx.lineCap = 'round';
    ctx.translate(
      props.boxConstraints.maxWidth / 2,
      props.boxConstraints.maxHeight / 2
    );

    ctx.beginPath();

    ctx.moveTo(
      props.points[0].x * props.scaleFactor,
      props.points[0].y * props.scaleFactor * -1
    );
    for (const point of props.points) {
      ctx.lineTo(point.x * props.scaleFactor, point.y * props.scaleFactor * -1);
    }
    ctx.stroke();
    ctx.closePath();
    ctx.setTransform(1, 0, 0, 1, 0, 0);
  }, [props.boxConstraints, props.points.length, props.scaleFactor, props.inverse]);

  return (
    <canvas
      style={{ position: 'absolute', top: 0, left: 0 }}
      ref={canvasRef}
      width={`${props.boxConstraints.maxWidth}`}
      height={`${props.boxConstraints.maxHeight}`}
    />
  );
}
